module.exports = __webpack_public_path__ + "static/media/1021406.c374a160.jpg";